define('commons/html-table-factory',['commons/json-to-html-converter', 'commons/template-chooser'], function(JsonToHtmlConverter, TemplateChooser) {
	return function(model, container) {
        var converter = new JsonToHtmlConverter();
        
        var templateChooser = new TemplateChooser(model.beanName, model.selectedFields, model.extra);
        if(model.filterCount > 0 || model.data.length > 0){
            // Remove empty message if displayed
            var $emptyMessageDiv = $('div#empty-message');
            if(!$emptyMessageDiv.hasClass('hidden')){
                $emptyMessageDiv.addClass('hidden');
                $('div#data-table-wrapper').removeClass('hidden');
                $('div#configure-columns-wrapper').removeClass('hidden');
            }
            
            // Empty old content
            $('div#configure-columns-wrapper').remove();
            $(container + ' div#data-table-wrapper table.data thead, ' + container + ' div#data-table-wrapper table.data tbody').empty();
            
            // Set filter results
            $('#table-count').toggle(model.filterCount >= 0 && model.totalCount >= 0);
            $('table.data').data('filterCount', model.filterCount);
            $('span#filter-count').html(model.filterCount);
            $('span#total-count').html(model.totalCount);
            
            // Set the pagination
            var $previousPage = $('a.previous-page');
            var $nextPage = $('a.next-page');
            if(model.page.hasPrevious){
                $previousPage.removeClass('hidden').data('params', model.page.previousPageParams);
            }else{
                $previousPage.addClass('hidden');
            }
            if(model.page.hasNext){
                $nextPage.removeClass('hidden').data('params', model.page.nextPageParams);
            }else{
                $nextPage.addClass('hidden');
            }
            $('.page-number').html('page '+ model.page.page);
            $('input#fullPage').attr('value', model.page.pageParams);
            $('input#page').attr('value', model.page.page);
            
            // Fill the table with some nice HTML
            converter.convert(templateChooser.buildHeaders(model.withSelector), model.headerContainer, null, $('<tr></tr>'), model.extra);
            converter.convert(templateChooser.buildDataTemplates(model.withSelector), model.bodyContainer, model.data, $('<tr></tr>'), model.extra);
        }else{
            $('div#configure-columns-wrapper').addClass('hidden');
            $('div#data-table-wrapper').addClass('hidden');
            $('div#empty-message').html(model.emptyMessage).removeClass('hidden');
        }
    };
});
